import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from "axios";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import coupleImage from '../../../assets/images/couples/Vector.png';
import { LoginContext } from '../../../context/LoginContext';
import { buildGothraOptions, gothraPayloadValue, isDontKnowGothra, resolveGothraSelection } from '../../../utils/gothra';
import Header from '../../profiles/Header';
import Footer from '../../Footer';


const EditProfile = () => {
  // Form data state


  const navigate = useNavigate();
  const param = useParams();
  const { userData, userName, userId, isLoggedIn, setUserdata } = useContext(LoginContext);
  const [APIformData, setAPIFormData] = useState({});
  const [originalPhone, setOriginalPhone] = useState('');
  const [originalEmail, setOriginalEmail] = useState('');
  const [mobileVerified, setMobileVerified] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);

  const [phoneOtpSent, setPhoneOtpSent] = useState(false);
  const [phoneOtpVerified, setPhoneOtpVerified] = useState(false);
  const [phoneOtpDigits, setPhoneOtpDigits] = useState(['', '', '', '']);
  const [phoneOtpBusy, setPhoneOtpBusy] = useState(false);
  const [phoneOtpMsg, setPhoneOtpMsg] = useState('');
  const phoneOtpRefs = useRef([]);

  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [emailOtpDigits, setEmailOtpDigits] = useState(['', '', '', '']);
  const [emailOtpBusy, setEmailOtpBusy] = useState(false);
  const [emailOtpMsg, setEmailOtpMsg] = useState('');
  const emailOtpRefs = useRef([]);



  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    description: '',
    subcaste: "",
    currentlocation: '',
    country: '',
    manglik: "",
    maritalStatus: "",
    height: '',
    weight: "",
    bodyType: "",
    physicalStatus: "",
    eatingHabits: "",
    drinkingHabits: "",
    smokingHabits: "",
    hobbies: "",
    highestEducation: "",
    educationQualification: "",
    occupation: "",
    employedIn: "",
    annualIncome: "",
    organizationName: "",
    caste: "",
    sisters: "",
    brothers: "",
    gothra: '',
    maternalGothra: '',
    familyStatus: "",
    familyType: "",
    familyBelongsTo: "",
    livingWithParents: "",
    state: "",
    city: "",
    pincode: "",
  });


  // const [formData, setFormData] = useState({
  //   description: `Hello, I am ${userData.name ? userData.name : "Hindu Sanjogian"}. Welcome to my profile. I am ${APIformData.age} years old. My height is ${APIformData.height}. This profile is created by ${APIformData.profileFor}. My mother tongue is ${APIformData.language}. I belong to a ${APIformData.family_type}. I am a ${APIformData.highest_education} and ${APIformData.occupation} by Profession. My hobbies are ${APIformData?.hobbies?.map((val, i) => ((i == 0) ? (val) : (` ${val}`)))}. If you like my profile let's connect further on HinduSanjog. Thank you 😊..`,
  //   subcaste: "",
  //   currentlocation: { label: "India", value: "India" },
  //   country: APIformData.country ? { label: APIformData.country, value: APIformData.country } : { label: "India", value: "India" },
  //   manglik: "",
  //   maritalStatus: "",
  //   height: APIformData.height ? { label: APIformData.height, value: APIformData.height } : "",
  //   weight: "",
  //   bodyType: "",
  //   physicalStatus: "",
  //   eatingHabits: "",
  //   drinkingHabits: "",
  //   smokingHabits: "",
  //   hobbies: APIformData.hobbies ? APIformData?.hobbies?.map(sel => ({ label: sel, value: sel })) : "",
  //   highestEducation: APIformData.highest_education ? { label: APIformData.highest_education, value: APIformData.highest_education } : "",
  //   educationQualification: "",
  //   occupation: APIformData.occupation ? { label: APIformData.occupation, value: APIformData.occupation } : "",
  //   employedIn: "",
  //   annualIncome: "",
  //   organizationName: "",
  //   caste: null,
  //   sisters: "",
  //   brothers: "",
  //   gothra: null,
  //   maternalGothra: null,
  //   familyStatus: "",
  //   familyType: APIformData.family_type ? { label: APIformData.family_type, value: APIformData.family_type } : "",
  //   familyBelongsTo: "",
  //   livingWithParents: "",
  //   state: APIformData.state ? { label: APIformData.state, value: APIformData.state } : "",
  //   city: null,
  //   pincode: ""
  // });

  // Options data state

  const [options, setOptions] = useState({
    caste: [],
    gothra: [],
    cities: [],
    countries: [],
    income: [],
    language: [],
    states: [],
    education: [],
    occupation: []
  });

  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({});


  // Fetch all dropdown options
  useEffect(() => {

    if (!isLoggedIn) {
      navigate("/login");
    }

    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);
    payload.append("find_id", param.id);


    const fetchOptions = async () => {
      try {
        setIsLoading(true);
        setErrors({});

        if (String(param.id) === String(userId)) {

          axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/view_profile`, payload)
            .then(response => {
              setAPIFormData(response.data.details);
              let data = response.data.details;
              setFormData({
                email: data.email || '',
                phone: data.phone || '',
                description: data.desc,
                subcaste: data.sub_caste,
                currentlocation: data.curr_location,
                country: data.country,
                manglik: data.manglik,
                maritalStatus: data.marital_status,
                height: data.height,
                weight: data.weight,
                bodyType: data.bdy_type,
                physicalStatus: data.ps,
                eatingHabits: data.eating,
                drinkingHabits: data.drinking,
                smokingHabits: data.smoking,
                hobbies: data.hobbies,
                highestEducation: data.highest_edu,
                educationQualification: data.ug_degree,
                occupation: data.occupation,
                employedIn: data.emp_in,
                annualIncome: data.annual_income,
                organizationName: data.org_name,
                caste: data.caste,
                brothers: data.brother,
                sisters: data.sister,
                gothra: data.gothra,
                maternalGothra: data.gothra_maternal,
                familyStatus: data.family_status,
                familyType: data.family_type,
                familyBelongsTo: data.family_based,
                livingWithParents: data.living_wth_parents,
                state: data.state,
                city: data.city,
                pincode: data.pin,
              });
              setOriginalPhone(String(data.phone || '').replace(/\D/g, '').slice(-10));
              setOriginalEmail(String(data.email || '').trim().toLowerCase());
              setMobileVerified(Number(data.verify_mobile) === 1);
              setEmailVerified(Number(data.verify_email) === 1);
              setPhoneOtpSent(false);
              setPhoneOtpVerified(Number(data.verify_mobile) === 1);
              setPhoneOtpDigits(['', '', '', '']);
              setPhoneOtpMsg('');
              setEmailOtpSent(false);
              setEmailOtpDigits(['', '', '', '']);
              setEmailOtpMsg('');
            })
            .catch(error => {
              console.error("There was an error fetching users!", error);
            });

        }






        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/caste.php`
        );

        const resp = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/education.php`
        );


        if (!response.data.success) {
          throw new Error(response.data.error || "Failed to fetch options");
        }


        // Transform all options to ensure they're arrays
        const transformedOptions = {
          caste: Array.isArray(response.data.data.caste) ? response.data.data.caste : [],
          gothra: Array.isArray(response.data.data.gothra) ? response.data.data.gothra : [],
          cities: Array.isArray(response.data.data.cities) ? response.data.data.cities : [],
          countries: Array.isArray(response.data.data.countries) ? response.data.data.countries : [],
          income: Array.isArray(response.data.data.income) ? response.data.data.income : [],
          language: Array.isArray(response.data.data.message) ? response.data.data.message : [],
          states: Array.isArray(response.data.data.states) ? response.data.data.states : [],
          subCaste: Array.isArray(response.data.data.subcaste) ? response.data.data.subcaste : [],
          education: Array.isArray(resp.data.data.education) ? resp.data.data.education : [],
          occupation: Array.isArray(resp.data.data.occupation) ? resp.data.data.occupation : []
        };

        setOptions(transformedOptions);
      } catch (err) {
        console.error("Error fetching options:", err);
        setErrors(err.message);
        // Initialize with empty arrays if request fails
        setOptions({
          caste: [],
          gothra: [],
          cities: [],
          countries: [],
          income: [],
          language: [],
          states: [],
          subCaste: [],
          education: [],
          occupation: []
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchOptions();
  }, [param.id]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const nextValue = name === 'phone' ? String(value).replace(/\D/g, '').slice(0, 10) : value;
    setFormData(prev => ({
      ...prev,
      [name]: nextValue
    }));

    if (name === 'phone') {
      const normalized = String(nextValue).replace(/\D/g, '').slice(-10);
      if (normalized !== originalPhone) {
        setPhoneOtpSent(false);
        setPhoneOtpVerified(false);
        setPhoneOtpDigits(['', '', '', '']);
        setPhoneOtpMsg('');
      } else {
        setPhoneOtpSent(false);
        setPhoneOtpVerified(mobileVerified);
        setPhoneOtpDigits(['', '', '', '']);
        setPhoneOtpMsg('');
      }
    }

    if (name === 'email') {
      const normalized = String(nextValue || '').trim().toLowerCase();
      if (normalized !== originalEmail) {
        setEmailVerified(false);
        setEmailOtpSent(false);
        setEmailOtpDigits(['', '', '', '']);
        setEmailOtpMsg('');
      } else {
        setEmailVerified(Number(APIformData.verify_email) === 1);
        setEmailOtpSent(false);
        setEmailOtpDigits(['', '', '', '']);
        setEmailOtpMsg('');
      }
    }

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

  };

  const phoneChanged = () => {
    const current = String(formData.phone || '').replace(/\D/g, '').slice(-10);
    return current !== '' && current !== originalPhone;
  };

  const emailChanged = () => {
    const current = String(formData.email || '').trim().toLowerCase();
    return current !== '' && current !== originalEmail;
  };

  const needsMobileVerifyUi = () => phoneChanged() || !mobileVerified;
  const needsEmailVerifyUi = () => emailChanged() || !emailVerified;

  const handleSendMobileOtp = async () => {
    const mobile = String(formData.phone || '').replace(/\D/g, '').slice(-10);
    if (!/^[6-9]\d{9}$/.test(mobile)) {
      setErrors(prev => ({ ...prev, phone: 'Enter a valid 10-digit mobile number' }));
      return;
    }

    setPhoneOtpBusy(true);
    setPhoneOtpMsg('');
    try {
      const payload = new FormData();
      payload.append('user_id', userId);
      let endpoint = 'Register_controller/verify_mobile_send_otp';
      if (phoneChanged()) {
        payload.append('mobile', mobile);
        endpoint = 'Register_controller/change_mobile_send_otp';
      }
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}${endpoint}`, payload);
      if (res.data.response === 'success') {
        if (res.data.already) {
          setMobileVerified(true);
          setPhoneOtpVerified(true);
          setPhoneOtpMsg(res.data.message);
        } else {
          setPhoneOtpSent(true);
          setPhoneOtpVerified(false);
          setPhoneOtpDigits(['', '', '', '']);
          setPhoneOtpMsg(res.data.message || 'OTP sent to your mobile number.');
          setTimeout(() => phoneOtpRefs.current[0]?.focus(), 50);
        }
      } else {
        setPhoneOtpMsg(res.data.message || 'Could not send OTP.');
      }
    } catch (err) {
      setPhoneOtpMsg('Could not send OTP. Please try again.');
    } finally {
      setPhoneOtpBusy(false);
    }
  };

  const handlePhoneOtpChange = (index, value) => {
    const digit = String(value).replace(/\D/g, '').slice(-1);
    const next = [...phoneOtpDigits];
    next[index] = digit;
    setPhoneOtpDigits(next);
    if (digit && index < 3) {
      phoneOtpRefs.current[index + 1]?.focus();
    }
  };

  const handleVerifyMobileOtp = async () => {
    const mobile = String(formData.phone || '').replace(/\D/g, '').slice(-10);
    const otp = phoneOtpDigits.join('');
    if (otp.length !== 4) {
      setPhoneOtpMsg('Enter the 4-digit OTP.');
      return;
    }

    setPhoneOtpBusy(true);
    setPhoneOtpMsg('');
    try {
      const payload = new FormData();
      payload.append('user_id', userId);
      payload.append('otp', otp);
      let endpoint = 'Register_controller/verify_mobile_confirm_otp';
      if (phoneChanged()) {
        payload.append('mobile', mobile);
        endpoint = 'Register_controller/change_mobile_verify_otp';
      }
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}${endpoint}`, payload);
      if (res.data.response === 'success') {
        const verifiedPhone = res.data.phone || mobile;
        setOriginalPhone(verifiedPhone);
        setMobileVerified(true);
        setPhoneOtpVerified(true);
        setPhoneOtpSent(false);
        setPhoneOtpMsg(res.data.message || 'Mobile number verified successfully.');
        setFormData(prev => ({ ...prev, phone: verifiedPhone }));
        setAPIFormData(prev => ({ ...prev, phone: verifiedPhone, verify_mobile: 1 }));
        setUserdata({
          ...userData,
          phone: verifiedPhone,
        });
      } else {
        setPhoneOtpMsg(res.data.message || 'Invalid or expired OTP.');
      }
    } catch (err) {
      setPhoneOtpMsg('Could not verify OTP. Please try again.');
    } finally {
      setPhoneOtpBusy(false);
    }
  };

  const handleSendEmailOtp = async () => {
    const email = String(formData.email || '').trim();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setErrors(prev => ({ ...prev, email: 'Enter a valid email' }));
      return;
    }

    setEmailOtpBusy(true);
    setEmailOtpMsg('');
    try {
      const payload = new FormData();
      payload.append('user_id', userId);
      payload.append('email', email);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}Register_controller/verify_email_send_otp`,
        payload
      );
      if (res.data.response === 'success') {
        if (res.data.already) {
          setEmailVerified(true);
          setEmailOtpMsg(res.data.message);
        } else {
          setEmailOtpSent(true);
          setEmailOtpDigits(['', '', '', '']);
          setEmailOtpMsg(res.data.message || 'OTP sent to your email address.');
          setTimeout(() => emailOtpRefs.current[0]?.focus(), 50);
        }
      } else {
        setEmailOtpMsg(res.data.message || 'Could not send email OTP.');
      }
    } catch (err) {
      setEmailOtpMsg('Could not send email OTP. Please try again.');
    } finally {
      setEmailOtpBusy(false);
    }
  };

  const handleEmailOtpChange = (index, value) => {
    const digit = String(value).replace(/\D/g, '').slice(-1);
    const next = [...emailOtpDigits];
    next[index] = digit;
    setEmailOtpDigits(next);
    if (digit && index < 3) {
      emailOtpRefs.current[index + 1]?.focus();
    }
  };

  const handleVerifyEmailOtp = async () => {
    const email = String(formData.email || '').trim();
    const otp = emailOtpDigits.join('');
    if (otp.length !== 4) {
      setEmailOtpMsg('Enter the 4-digit OTP.');
      return;
    }

    setEmailOtpBusy(true);
    setEmailOtpMsg('');
    try {
      const payload = new FormData();
      payload.append('user_id', userId);
      payload.append('email', email);
      payload.append('otp', otp);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}Register_controller/verify_email_confirm_otp`,
        payload
      );
      if (res.data.response === 'success') {
        const verifiedEmail = res.data.email || email;
        setOriginalEmail(String(verifiedEmail).toLowerCase());
        setEmailVerified(true);
        setEmailOtpSent(false);
        setEmailOtpMsg(res.data.message || 'Email verified successfully.');
        setFormData(prev => ({ ...prev, email: verifiedEmail }));
        setAPIFormData(prev => ({ ...prev, email: verifiedEmail, verify_email: 1 }));
        setUserdata({
          ...userData,
          email: verifiedEmail,
        });
      } else {
        setEmailOtpMsg(res.data.message || 'Invalid or expired OTP.');
      }
    } catch (err) {
      setEmailOtpMsg('Could not verify email OTP. Please try again.');
    } finally {
      setEmailOtpBusy(false);
    }
  };


  // Handle select changes
  const handleSelectChange = (name, selectedOption) => {
    setFormData(prev => ({
      ...prev,
      [name]: selectedOption
    }));

  };



  const validateForm = () => {
    /////after Fill Validate form
    const newErrors = {};

    if (!formData.email || !String(formData.email).trim()) newErrors.email = "Email is Required";
    else if (!/^\S+@\S+\.\S+$/.test(String(formData.email).trim())) newErrors.email = "Enter a valid email";
    else if (emailChanged() && !emailVerified) {
      newErrors.email = "Verify the new email with OTP before saving";
    }
    if (!formData.phone || !String(formData.phone).trim()) newErrors.phone = "Mobile number is Required";
    else if (!/^[6-9]\d{9}$/.test(String(formData.phone).trim())) newErrors.phone = "Enter a valid 10-digit mobile number";
    else if (phoneChanged() && !phoneOtpVerified) {
      newErrors.phone = "Verify the new mobile number with OTP before saving";
    }
    if (!formData.description.trim()) newErrors.description = "Description is Required";
    if (!formData.subcaste) newErrors.subcaste = "Sub Caste Is Required";
    if (!formData.currentlocation) newErrors.currentlocation = "Please Select Current location";
    if (!formData.manglik) newErrors.manglik = "Manglik is Required";
    if (!formData.maritalStatus) newErrors.maritalStatus = "Martial Status is Required";
    if (!formData.height) newErrors.height = "Height is Required";
    if (!formData.weight) newErrors.weight = "Weight is Required";
    if (!formData.bodyType) newErrors.bodyType = "Body Type is Required";
    if (!formData.physicalStatus) newErrors.physicalStatus = "Physical Status is Required";
    if (!formData.eatingHabits) newErrors.eatingHabits = "Eating Habits is Required";
    if (!formData.drinkingHabits) newErrors.drinkingHabits = "Drinking Habits is Required";
    if (!formData.smokingHabits) newErrors.smokingHabits = "Somking is Required";
    if (formData.hobbies.length < 1) newErrors.hobbies = "Hobbies are Required";
    if (!formData.highestEducation) newErrors.highestEducation = "Highest Education is Required";
    if (!formData.educationQualification) newErrors.educationQualification = "Education Qualification is Required";
    if (!formData.occupation) newErrors.occupation = "Occupation is Required";
    if (!formData.employedIn) newErrors.employedIn = "Employed In is Required";
    if (!formData.annualIncome) newErrors.annualIncome = "Annual Income is Required";
    if (!formData.sisters) newErrors.sisters = "Sister(s) is Required";
    if (!formData.brothers) newErrors.brothers = "Brother(s) is Required";
    if (!formData.gothra && !isDontKnowGothra(formData.gothra)) newErrors.gothra = "Gothra is Required";
    if (!formData.maternalGothra && !isDontKnowGothra(formData.maternalGothra)) newErrors.maternalGothra = "Maternal Gothra is Required";
    if (!formData.familyStatus) newErrors.familyStatus = "Family Status is Required";
    if (!formData.familyBelongsTo) newErrors.familyBelongsTo = "Family Belongs To is Required";
    if (!formData.familyType) newErrors.familyType = "Familty Type is Required";
    if (!formData.livingWithParents) newErrors.livingWithParents = "Living With is Required";
    if (!formData.country) newErrors.country = "Country is Required";
    if (!formData.state) newErrors.state = "State is Required";
    if (!formData.city) newErrors.city = "City is Required";
    if (!formData.pincode) newErrors.pincode = "Pin Code is Required";



    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }




  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;


    try {
      const payload = new FormData();
      /// // payload.append('user_id', userId);
      payload.append('id', userId);
      payload.append('email', String(formData.email || '').trim());
      payload.append('phone', String(formData.phone || '').trim());
      payload.append('desc', formData.description);
      payload.append('sub_caste', (formData.subcaste.value) ? (formData.subcaste.value) : (formData.subcaste));
      payload.append('ms', (formData.maritalStatus.value) ? (formData.maritalStatus.value) : (formData.maritalStatus));
      payload.append('height', (formData.height.value) ? (formData.height.value) : (formData.height));
      payload.append('weight', (formData.weight));
      payload.append('body', (formData.bodyType.value) ? (formData.bodyType.value) : (formData.bodyType));
      payload.append('ps', (formData.physicalStatus.value) ? (formData.physicalStatus.value) : (formData.physicalStatus));
      payload.append('eating', (formData.eatingHabits.value) ? (formData.eatingHabits.value) : (formData.eatingHabits));
      payload.append('drinking', (formData.drinkingHabits.value) ? (formData.drinkingHabits.value) : (formData.drinkingHabits));
      payload.append('smoking', (formData.smokingHabits.value) ? (formData.smokingHabits.value) : (formData.smokingHabits));
      payload.append('hobbies', (Array.isArray(formData.hobbies)) ? (Object.values(formData.hobbies.map(val => (val.value)))) : (formData.hobbies));

      // Object.values(formData.hobbies.map(val=>( val.value)))


      payload.append('curr_location', (formData.currentlocation.value) ? (formData.currentlocation.value) : (formData.currentlocation));
      payload.append('manglik', (formData.manglik.value) ? (formData.manglik.value) : (formData.manglik));


      // ///contact table 
      payload.append('city', (formData.city.value) ? (formData.city.value) : (formData.city));
      payload.append('country', (formData.country.value) ? (formData.country.value) : (formData.country));
      payload.append('state', (formData.state.value) ? (formData.state.value) : (formData.state));
      payload.append('pin', (formData.pincode));

      // ///education Table
      payload.append("highest_edu", (formData.highestEducation.value) ? (formData.highestEducation.value) : (formData.highestEducation));
      payload.append("ug_degree", (formData.educationQualification.value) ? (formData.educationQualification.value) : (formData.educationQualification));
      payload.append("emp_in", (formData.employedIn.value) ? (formData.employedIn.value) : (formData.employedIn));
      payload.append("occupation", (formData.occupation.value) ? (formData.occupation.value) : (formData.occupation));
      payload.append("org_name", (formData.organizationName.value) ? (formData.organizationName.value) : (formData.organizationName));
      payload.append("annual_income", (formData.annualIncome.value) ? (formData.annualIncome.value) : (formData.annualIncome));

      // ///family Table
      payload.append("sister", (formData.sisters.value) ? (formData.sisters.value) : (formData.sisters));
      payload.append("brother", (formData.brothers.value) ? (formData.brothers.value) : (formData.brothers));
      payload.append("gothra", gothraPayloadValue(formData.gothra));
      payload.append("gothra_maternal", gothraPayloadValue(formData.maternalGothra));
      payload.append("family_status", (formData.familyStatus.value) ? (formData.familyStatus.value) : (formData.familyStatus));
      payload.append("family_type", (formData.familyType.value) ? (formData.familyType.value) : (formData.familyType));
      payload.append("family_based", (formData.familyBelongsTo.value) ? (formData.familyBelongsTo.value) : (formData.familyBelongsTo));
      payload.append("living_wth_parents", (formData.livingWithParents.value) ? (formData.livingWithParents.value) : (formData.livingWithParents));


      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}Register_controller/updateProfileData`,
        payload
      );

      if (response.data.response == "success") {
        const savedPhone = response.data.phone || originalPhone || String(formData.phone || '').trim();
        setUserdata({
          ...userData,
          email: String(formData.email || '').trim(),
          phone: savedPhone,
        });
        navigate('/view-profile/' + userId);
      } else {
        setErrors({
          api: response.data.message || 'Failed to update profile',
          ...(response.data.field ? { [response.data.field]: response.data.message } : {}),
        });
      }

    } catch (error) {
      console.log('Error While Posting Data:', error);
    }
  };

  if (isLoading) {
    return (<div className='custom-loader-g'><div class="spinner-border text-danger" role="status"><span class="sr-only">Loading...</span></div></div>);
  }

  // if (error) {
  //   return <div className="error">Error: {error}</div>;
  // }

  return (

    <>
      <Header></Header>


      <div className='create-profile-wrapper'>
        <div className='container pt-4'>
          <div className="create-profile-container" style={{ borderRadius: "1rem", boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)" }}>
            {/* Left Side Form */}
            <div className="create-profile-form-side py-4">
              <h1 className="create-profile-heading mb-0 text-center">Edit Profile</h1>
              {/* <p className="create-profile-subheading">Start your journey here</p> */}
              <h3 className="form-section-title my-0 text-center">Basic Details</h3>

              <form className="create-profile-form" onSubmit={handleSubmit}>
                {/* Section 1: Basic Details */}

                {errors.api && (
                  <div className="alert alert-danger text-center">{errors.api}</div>
                )}

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">
                      Email ID *
                      {emailVerified && !emailChanged() ? (
                        <span style={{ marginLeft: 8, color: '#16a34a', fontSize: 12, fontWeight: 600 }}>Verified</span>
                      ) : (
                        <span style={{ marginLeft: 8, color: '#9ca3af', fontSize: 12, fontWeight: 600 }}>Not verified</span>
                      )}
                    </label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="Enter your email"
                        value={formData.email || ''}
                        onChange={handleInputChange}
                        autoComplete="email"
                        style={{ flex: 1 }}
                      />
                      {needsEmailVerifyUi() && !emailVerified && (
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={handleSendEmailOtp}
                          disabled={emailOtpBusy}
                          style={{ whiteSpace: 'nowrap', minHeight: '38px' }}
                        >
                          {emailOtpBusy && !emailOtpSent ? 'Sending...' : (emailOtpSent ? 'Resend OTP' : 'Verify Email')}
                        </button>
                      )}
                    </div>
                    {needsEmailVerifyUi() && !emailVerified && (
                      <small style={{ display: 'block', marginTop: '4px', color: '#666' }}>
                        {emailChanged()
                          ? 'New email must be verified with OTP before saving.'
                          : 'Click Verify Email to receive an OTP on this address.'}
                      </small>
                    )}
                    {emailOtpSent && !emailVerified && (
                      <div style={{ marginTop: '10px' }}>
                        <label className="form-label">Enter Email OTP *</label>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                          {emailOtpDigits.map((digit, index) => (
                            <input
                              key={index}
                              ref={(el) => (emailOtpRefs.current[index] = el)}
                              type="text"
                              inputMode="numeric"
                              maxLength={1}
                              value={digit}
                              onChange={(e) => handleEmailOtpChange(index, e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Backspace' && !emailOtpDigits[index] && index > 0) {
                                  emailOtpRefs.current[index - 1]?.focus();
                                }
                              }}
                              className="form-control"
                              style={{ width: '44px', textAlign: 'center', fontSize: '18px' }}
                            />
                          ))}
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleVerifyEmailOtp}
                            disabled={emailOtpBusy}
                          >
                            {emailOtpBusy ? 'Verifying...' : 'Verify OTP'}
                          </button>
                        </div>
                      </div>
                    )}
                    {emailOtpMsg && (
                      <span
                        style={{
                          color: emailVerified || String(emailOtpMsg).toLowerCase().includes('sent') ? 'green' : 'red',
                          fontSize: '12px',
                          display: 'block',
                          marginTop: '4px',
                        }}
                      >
                        {emailOtpMsg}
                      </span>
                    )}
                    {errors.email && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.email}</span>}
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      Mobile Number *
                      {mobileVerified && !phoneChanged() ? (
                        <span style={{ marginLeft: 8, color: '#16a34a', fontSize: 12, fontWeight: 600 }}>Verified</span>
                      ) : (
                        <span style={{ marginLeft: 8, color: '#9ca3af', fontSize: 12, fontWeight: 600 }}>Not verified</span>
                      )}
                    </label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                      <input
                        type="tel"
                        className="form-control"
                        name="phone"
                        placeholder="10-digit mobile number"
                        value={formData.phone || ''}
                        onChange={handleInputChange}
                        maxLength={10}
                        autoComplete="tel"
                        style={{ flex: 1 }}
                      />
                      {needsMobileVerifyUi() && !(mobileVerified && !phoneChanged()) && (
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={handleSendMobileOtp}
                          disabled={phoneOtpBusy}
                          style={{ whiteSpace: 'nowrap', minHeight: '38px' }}
                        >
                          {phoneOtpBusy && !phoneOtpSent
                            ? 'Sending...'
                            : (phoneOtpSent
                              ? 'Resend OTP'
                              : (phoneChanged() ? 'Send OTP' : 'Verify Mobile'))}
                        </button>
                      )}
                    </div>
                    {needsMobileVerifyUi() && !(mobileVerified && !phoneChanged()) && (
                      <small style={{ display: 'block', marginTop: '4px', color: '#666' }}>
                        {phoneChanged()
                          ? 'Change requires OTP verification on the new number.'
                          : 'Click Verify Mobile to receive an OTP on this number.'}
                      </small>
                    )}
                    {phoneOtpSent && !(mobileVerified && !phoneChanged()) && !phoneOtpVerified && (
                      <div style={{ marginTop: '10px' }}>
                        <label className="form-label">Enter Mobile OTP *</label>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                          {phoneOtpDigits.map((digit, index) => (
                            <input
                              key={index}
                              ref={(el) => (phoneOtpRefs.current[index] = el)}
                              type="text"
                              inputMode="numeric"
                              maxLength={1}
                              value={digit}
                              onChange={(e) => handlePhoneOtpChange(index, e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Backspace' && !phoneOtpDigits[index] && index > 0) {
                                  phoneOtpRefs.current[index - 1]?.focus();
                                }
                              }}
                              className="form-control"
                              style={{ width: '44px', textAlign: 'center', fontSize: '18px' }}
                            />
                          ))}
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleVerifyMobileOtp}
                            disabled={phoneOtpBusy}
                          >
                            {phoneOtpBusy ? 'Verifying...' : 'Verify OTP'}
                          </button>
                        </div>
                      </div>
                    )}
                    {phoneOtpMsg && (
                      <span
                        className="field-error"
                        style={{
                          color: phoneOtpVerified || mobileVerified || (phoneOtpMsg && phoneOtpMsg.toLowerCase().includes('sent')) ? 'green' : 'red',
                          fontSize: '12px',
                          display: 'block',
                          marginTop: '4px',
                        }}
                      >
                        {phoneOtpMsg}
                      </span>
                    )}
                    {errors.phone && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.phone}</span>}
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Description</label>
                  <textarea
                    rows={6}
                    className="form-textarea"
                    name="description"
                    placeholder="Write something about yourself..."
                    value={(formData.description) ? formData.description : APIformData.desc}
                    onChange={handleInputChange}
                  />
                  {errors.description && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.description}</span>}

                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Sub Caste</label>
                    <Select
                      options={options?.subCaste?.map(caste => ({
                        label: caste,
                        value: caste
                      }))}
                      value={(formData.subcaste.value) ? (formData.subcaste) : ({ label: formData.subcaste, value: formData.subcaste })}
                      onChange={(selected) => handleSelectChange("subcaste", selected)}
                      placeholder="Select Sub Caste"
                    />
                    {errors.subcaste && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.subcaste}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Current Location *</label>
                    <Select
                      options={options?.countries?.map(country => ({
                        label: country,
                        value: country
                      }))}
                      value={(formData.currentlocation.value) ? (formData.currentlocation) : ({ label: formData.currentlocation, value: formData.currentlocation })}

                      onChange={(selected) => handleSelectChange("currentlocation", selected)}
                      placeholder="Select Country"
                      isDisabled={options.countries.length === 0}
                    />
                    {errors.currentlocation && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.currentlocation}</span>}

                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Manglik Dosha</label>



                    <Select
                      options={["Yes", "No", "Don't Know"].map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.manglik.value) ? (formData.manglik) : ({ label: formData.manglik, value: formData.manglik })}
                      onChange={(selected) => handleSelectChange("manglik", selected)}
                      placeholder="Select Maglik"

                    />
                    {errors.manglik && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.manglik}</span>}


                  </div>
                  <div className="form-group">
                    <label className="form-label">Marital Status *</label>


                    <Select
                      options={["Single", "Divorce", "Widowed"].map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.maritalStatus.value) ? (formData.maritalStatus) : ({ label: formData.maritalStatus, value: formData.maritalStatus })}
                      onChange={(selected) => handleSelectChange("maritalStatus", selected)}
                      placeholder="Select Marital Status"

                    />
                    {errors.maritalStatus && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.maritalStatus}</span>}

                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Height (in feet) *</label>


                    <Select
                      options={Array.from({ length: 4 }, (_, f) => 4 + f) // 4 to 7
                        .flatMap(feet =>
                          Array.from({ length: 12 }, (_, inches) => {
                            if (feet === 7 && inches > 0) return null;
                            return { label: `${feet}.${inches} Ft`, value: `${feet}.${inches}` }
                          }).filter(Boolean)
                        )}
                      value={(formData.height.value) ? (formData.height) : ({ label: `${formData.height} Ft`, value: formData.height })}
                      onChange={(selected) => handleSelectChange("height", selected)}
                      placeholder="Select Height"

                    />
                    {errors.height && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.height}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Weight (in Kg)</label>

                    <Select
                      options={[...Array.from({ length: 111 }, (_, i) => i + 40).map(val => ({ label: `${val} Kg`, value: `${val}` })), { label: `150+ Kg`, value: `150+` }]}

                      value={(formData.weight.value) ? (formData.weight) : ({ label: `${formData.weight} Kg`, value: formData.weight })}
                      onChange={(selected) => handleSelectChange("weight", selected)}
                      placeholder="Select Weight"
                    />
                    {errors.weight && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.weight}</span>}
                  </div>
                </div>


                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Body Type *</label>


                    <Select
                      options={Array("Slim", "Average", "Athletic", "Heavy").map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.bodyType.value) ? (formData.bodyType) : ({ label: formData.bodyType, value: formData.bodyType })}
                      onChange={(selected) => handleSelectChange("bodyType", selected)}
                      placeholder="Select Body Type"
                    />
                    {errors.bodyType && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.bodyType}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Physical Status : *</label>



                    <Select
                      options={Array("Normal", "Physically Challenged").map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.physicalStatus.value) ? (formData.physicalStatus) : ({ label: formData.physicalStatus, value: formData.physicalStatus })}
                      onChange={(selected) => handleSelectChange("physicalStatus", selected)}
                      placeholder="Select Physical Status"
                    />
                    {errors.physicalStatus && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.physicalStatus}</span>}

                  </div>
                </div>


                <div className="form-row">

                  <div className="form-group">
                    <label className="form-label">Eating Habits : </label>


                    <Select
                      options={Array("Vegetarian", "Non-Vegetarian", "Jain", "Eggetarian").map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.eatingHabits.value) ? (formData.eatingHabits) : ({ label: formData.eatingHabits, value: formData.eatingHabits })}
                      onChange={(selected) => handleSelectChange("eatingHabits", selected)}
                      placeholder="Select Eating Habits"
                    />
                    {errors.eatingHabits && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.eatingHabits}</span>}

                  </div>

                  <div className="form-group">
                    <label className="form-label">Drinking Habits : </label>


                    <Select
                      options={Array("Yes", "No", "Occasionally").map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.drinkingHabits.value) ? (formData.drinkingHabits) : ({ label: formData.drinkingHabits, value: formData.drinkingHabits })}
                      onChange={(selected) => handleSelectChange("drinkingHabits", selected)}
                      placeholder="Select Drinking Habits"
                    />

                    {errors.drinkingHabits && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.drinkingHabits}</span>}



                  </div>

                </div>



                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Smoking Habits : </label>



                    <Select
                      options={Array("Yes", "No", "Occasionally").map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.smokingHabits.value) ? (formData.smokingHabits) : ({ label: formData.smokingHabits, value: formData.smokingHabits })}
                      onChange={(selected) => handleSelectChange("smokingHabits", selected)}
                      placeholder="Select Smoking Habits"
                    />

                    {errors.smokingHabits && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.smokingHabits}</span>}

                  </div>
                </div>


                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Hobbies : </label>




                    <Select

                      options={[
                        {
                          label: "Creative & Artistic",
                          options: [
                            { value: "drawing", label: "Drawing" },
                            { value: "painting", label: "Painting" },
                            { value: "writing", label: "Writing" },
                            { value: "photography", label: "Photography" },
                            { value: "calligraphy", label: "Calligraphy" },
                            { value: "scrapbooking", label: "Scrapbooking" },
                            { value: "sewing", label: "Sewing" },
                            { value: "knitting", label: "Knitting" },
                            { value: "crocheting", label: "Crocheting" },
                            { value: "woodworking", label: "Woodworking" },
                            { value: "metalworking", label: "Metalworking" },
                            { value: "lego", label: "LEGO Building" },
                            { value: "model_building", label: "Model Building" },
                            { value: "home_decor", label: "Home Decor" },
                            { value: "interior_design", label: "Interior Design" },
                          ],
                        },
                        {
                          label: "Performance & Entertainment",
                          options: [
                            { value: "dancing", label: "Dancing" },
                            { value: "singing", label: "Singing" },
                            { value: "playing_music", label: "Playing Musical Instruments" },
                            { value: "acting", label: "Acting" },
                            { value: "magic", label: "Magic Tricks" },
                            { value: "vlogging", label: "Vlogging" },
                            { value: "podcasting", label: "Podcasting" },
                            { value: "blogging", label: "Blogging" },
                          ],
                        },
                        {
                          label: "Outdoor & Physical",
                          options: [
                            { value: "hiking", label: "Hiking" },
                            { value: "camping", label: "Camping" },
                            { value: "fishing", label: "Fishing" },
                            { value: "gardening", label: "Gardening" },
                            { value: "cycling", label: "Cycling" },
                            { value: "running", label: "Running" },
                            { value: "swimming", label: "Swimming" },
                            { value: "yoga", label: "Yoga" },
                            { value: "meditation", label: "Meditation" },
                            { value: "surfing", label: "Surfing" },
                            { value: "skateboarding", label: "Skateboarding" },
                            { value: "skiing", label: "Skiing" },
                            { value: "snowboarding", label: "Snowboarding" },
                            { value: "horseback_riding", label: "Horseback Riding" },
                            { value: "archery", label: "Archery" },
                            { value: "martial_arts", label: "Martial Arts" },
                          ],
                        },
                        {
                          label: "Tech & Digital",
                          options: [
                            { value: "gaming", label: "Gaming" },
                            { value: "coding", label: "Coding" },
                            { value: "robotics", label: "Robotics" },
                            { value: "3d_printing", label: "3D Printing" },
                            { value: "investing", label: "Investing" },
                            { value: "language_learning", label: "Learning Languages" },
                          ],
                        },
                        {
                          label: "Culinary",
                          options: [
                            { value: "cooking", label: "Cooking" },
                            { value: "baking", label: "Baking" },
                          ],
                        },
                        {
                          label: "Mind & Collection",
                          options: [
                            { value: "reading", label: "Reading" },
                            { value: "puzzles", label: "Puzzles" },
                            { value: "board_games", label: "Board Games" },
                            { value: "collecting_stamps", label: "Stamp Collecting" },
                            { value: "collecting_coins", label: "Coin Collecting" },
                            { value: "birdwatching", label: "Birdwatching" },
                            { value: "bird_breeding", label: "Bird Breeding" },
                            { value: "geocaching", label: "Geocaching" },
                            { value: "astrology", label: "Astrology" },
                            { value: "astronomy", label: "Astronomy" },
                          ],
                        },
                        {
                          label: "Media & Entertainment",
                          options: [
                            { value: "movies", label: "Watching Movies" },
                            { value: "tv_series", label: "Watching TV Series" },
                            { value: "anime", label: "Watching Anime" },
                            { value: "traveling", label: "Traveling" },
                          ],
                        },
                        {
                          label: "Community & Social",
                          options: [
                            { value: "volunteering", label: "Volunteering" },
                          ],
                        }
                      ]}

                      isMulti={true}
                      value={(Array.isArray(formData.hobbies)) ? (formData.hobbies) : (formData?.hobbies?.split(",")?.map(h => ({ label: h.trim().slice(0, 1).toUpperCase() + h.trim().slice(1, h.trim().length), value: h.trim() })))}
                      onChange={(selected) => handleSelectChange("hobbies", selected)}
                      placeholder="Select Hobbies"
                    />


                    {errors.hobbies && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.hobbies}</span>}


                  </div>


                </div>








                {/* Section 2: Education & Career */}
                <h3 className="form-section-title text-center my-2">Education & Career</h3>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Highest Education *</label>

                    <Select
                      options={Array("Not Educated", "10th Pass", "12th Pass", "Diploma", "Graduate", "M Phil", "PHD", "Other").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.highestEducation.value) ? (formData.highestEducation) : ({ label: formData.highestEducation, value: formData.highestEducation })}
                      onChange={(selected) => handleSelectChange("highestEducation", selected)}
                      placeholder="Select Highest Education"
                    />


                    {errors.highestEducation && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.highestEducation}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Education Qualification</label>

                    <Select
                      options={options?.education?.map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.educationQualification.value) ? (formData.educationQualification) : ({ label: formData.educationQualification, value: formData.educationQualification })}
                      onChange={(selected) => handleSelectChange("educationQualification", selected)}
                      placeholder="Select Qualtification"
                    />


                    {errors.educationQualification && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.educationQualification}</span>}

                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Occupation *</label>


                    <Select
                      options={options?.occupation?.map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.occupation.value) ? (formData.occupation) : ({ label: formData.occupation, value: formData.occupation })}
                      onChange={(selected) => handleSelectChange("occupation", selected)}
                      placeholder="Select Occupation"
                    />


                    {errors.occupation && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.occupation}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Employed In</label>


                    <Select
                      options={Array("Private Sector", "Government / Puboptionc Sector", "Civil Services", "Defence", "Self- Employed", "Unemployed").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.employedIn.value) ? (formData.employedIn) : ({ label: formData.employedIn, value: formData.employedIn })}
                      onChange={(selected) => handleSelectChange("employedIn", selected)}
                      placeholder="Select Employed In"
                    />


                    {errors.employedIn && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.employedIn}</span>}
                  </div>
                </div>


                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Annual Income *</label>

                    <Select
                      options={options?.income?.map((val, index) => ({
                        label: val,
                        value: parseInt(index + 1)
                      }))}
                      value={(formData.annualIncome.value) ? (formData.annualIncome) : ({ label: (APIformData.income), value: parseInt(formData.annualIncome) })}
                      onChange={(selected) => handleSelectChange("annualIncome", selected)}
                      placeholder="Select Income"
                    />


                    {errors.annualIncome && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.annualIncome}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Company Name</label>

                    <input name="organizationName" className='form-control' onChange={handleInputChange} value={(formData.organizationName) ? (formData.organizationName) : (APIformData.org_name)} type='Text' />

                  </div>
                </div>

                {/* Section 3: Family Details */}
                <h3 className="form-section-title text-center my-2">Family Details</h3>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Sister(s)</label>

                    <Select
                      options={Array('0', '1', '2', '3', '3+').map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.sisters.value) ? (formData.sisters) : ({ label: formData.sisters, value: formData.sisters })}
                      onChange={(selected) => handleSelectChange("sisters", selected)}
                      placeholder="Select Sister"
                    />


                    {errors.sisters && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.sisters}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Brother(s)</label>


                    <Select
                      options={Array('0', '1', '2', '3', '3+').map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.brothers.value) ? (formData.brothers) : ({ label: formData.brothers, value: formData.brothers })}
                      onChange={(selected) => handleSelectChange("brothers", selected)}
                      placeholder="Select Brothers"
                    />


                    {errors.brothers && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.brothers}</span>}


                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Gothra</label>
                    <Select
                      options={buildGothraOptions(options.gothra, { numericValue: true })}
                      value={(formData.gothra && formData.gothra.value !== undefined) ? (formData.gothra) : resolveGothraSelection(formData.gothra, APIformData.gothraname, { numericValue: true })}
                      onChange={(selected) => handleSelectChange("gothra", selected)}
                      placeholder="Select Gothra"
                      isDisabled={options.gothra.length === 0}
                    />

                    {errors.gothra && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.gothra}</span>}
                  </div>
                  <div className="form-group">
                    <label className="form-label">Gothra (Maternal)</label>
                    <Select
                      options={buildGothraOptions(options.gothra, { numericValue: true })}
                      value={(formData.maternalGothra && formData.maternalGothra.value !== undefined) ? (formData.maternalGothra) : resolveGothraSelection(formData.maternalGothra, APIformData.gothramaternalname, { numericValue: true })}
                      onChange={(selected) => handleSelectChange("maternalGothra", selected)}
                      placeholder="Select Maternal Gothra"
                      isDisabled={options.gothra.length === 0}
                    />


                    {errors.maternalGothra && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.maternalGothra}</span>}
                  </div>
                </div>




                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Family Status</label>


                    <Select
                      options={Array("Rich/Affluent", "Upper Middle", "Middle Class").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.familyStatus.value) ? (formData.familyStatus) : ({ label: formData.familyStatus, value: formData.familyStatus })}
                      onChange={(selected) => handleSelectChange("familyStatus", selected)}
                      placeholder="Select Family Status"
                    />

                    {errors.familyStatus && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.familyStatus}</span>}



                  </div>
                  <div className="form-group">
                    <label className="form-label">Family Type</label>

                    <Select
                      options={Array("Joint Family", "Nuclear Family").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.familyType.value) ? (formData.familyType) : ({ label: formData.familyType, value: formData.familyType })}
                      onChange={(selected) => handleSelectChange("familyType", selected)}
                      placeholder="Select Family Type"
                    />

                    {errors.familyType && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.familyType}</span>}



                  </div>
                </div>



                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Family Belongs To </label>
                    <Select
                      options={options?.states?.map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.familyBelongsTo.value) ? (formData.familyBelongsTo) : ({ label: formData.familyBelongsTo, value: formData.familyBelongsTo })}
                      onChange={(selected) => handleSelectChange("familyBelongsTo", selected)}
                      placeholder="Select Family Belongs To"


                    />



                    {errors.familyBelongsTo && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.familyBelongsTo}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Living with parents?</label>

                    <Select
                      options={Array("Yes", "No", "Not Applicable").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.livingWithParents.value) ? (formData.livingWithParents) : ({ label: formData.livingWithParents, value: formData.livingWithParents })}
                      onChange={(selected) => handleSelectChange("livingWithParents", selected)}
                      placeholder="Select Living With Parents"
                    />

                    {errors.livingWithParents && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.livingWithParents}</span>}



                  </div>
                </div>





                <div className="form-row">

                  <div className="form-group">
                    <label className="form-label">Country</label>

                    <Select
                      options={options?.countries?.map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.country.value) ? (formData.country) : ({ label: formData.country, value: formData.country })}
                      onChange={(selected) => handleSelectChange("country", selected)}
                      placeholder="Select Country"
                      defaultValue={{ label: "India", value: "India" }}
                    />


                    {errors.country && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.country}</span>}

                  </div>

                  <div className="form-group">
                    <label className="form-label">Current State *</label>
                    <Select
                      options={options.states.map(state => ({
                        label: state,
                        value: state
                      }))}
                      value={(formData.state.value) ? (formData.state) : ({ label: formData.state, value: formData.state })}
                      onChange={(selected) => handleSelectChange("state", selected)}
                      placeholder="Select State"
                      isDisabled={options.states.length === 0}
                    />


                    {errors.state && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.state}</span>}
                  </div>

                </div>


                <div className="form-row">

                  <div className="form-group">
                    <label className="form-label">Current City</label>
                    <Select
                      options={options.cities.map(city => ({
                        label: city,
                        value: city
                      }))}
                      value={(formData.city.value) ? (formData.city) : ({ label: formData.city, value: formData.city })}
                      onChange={(selected) => handleSelectChange("city", selected)}
                      placeholder="Select City"
                      isDisabled={options.cities.length === 0}
                    />


                    {errors.city && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.city}</span>}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Pin Code *</label>
                    <input type='text' className='form-control' name='pincode' onChange={handleInputChange} value={(formData.pincode) ? (formData.pincode) : APIformData.pin} />

                    {errors.pincode && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.pincode}</span>}
                  </div>


                </div>

                <button type="submit" className="create-btn mt-3">Update</button>
              </form>
            </div>

            {/* Right Side Image */}
            <div className="create-profile-image-side position-relative d-none d-lg-block">
              <img src={coupleImage} alt="Couple" className="couple-image" />
              <div className="image-overlay position-absolute" style={{ bottom: "50px" }}>
                <h2 className="overlay-heading">
                  Your Journey To Love Begins <span className="highlight">Here!</span>
                </h2>
                <p className="overlay-text">
                  Connect With Genuine Matches <br/> Who Share Your <span className="highlight">Values</span> And <span className="highlight">Dreams</span>.
                </p>
              </div>
            </div>
          </div>
        </div>

        <style>
          {`
        /* Main Layout */
           .css-b62m3t-container{
margin-top:0 !important;
           }
        .form-group select,.form-group input
        {
        background:white;
        border-radius:15px;
        }
        .create-profile-wrapper {
          min-height: 100vh;
          background-color: #fff;
        }

        .create-profile-logo {
          max-width: 180px;
          margin: 20px;
        }

        .create-profile-container {
          display: flex;
          height: calc(100vh - 80px);
          overflow: hidden;
        }

        /* Form Side Styles */
        .create-profile-form-side {
          width: 60%;
          padding: 40px;
          overflow-y: auto;
          background-color: #fff;
        }

        .create-profile-heading {
          font-size: 2rem;
          color: #333;
          margin-bottom: 0.5rem;
        }

        .create-profile-subheading {
          color: #666;
          margin-bottom: 2rem;
          font-size: 1rem;
        }

        .create-profile-form {
          display: flex;
          flex-direction: column;
          gap:0 1.5rem;
        }

        .form-section-title {
          margin-top: 2rem;
          color: #E53D5C;
          font-size: 1.3rem;
          font-weight: 600;
        }

        /* Form Elements */
        .form-group {
          display: flex;
          flex-direction: column;
          gap:3px 0.5rem;
        }

        .form-label {
          font-size: 0.9rem;
          font-weight: 500;
          color: #333;
        }

        .form-input,
        .form-select,
        .form-textarea {
          padding: 0.8rem;
          border-radius: 6px;
          border: 1px solid #ccc;
          font-size: 1rem;
          transition: border-color 0.2s;
        }

        .form-input:focus,
        .form-select:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #E53D5C;
        }

        .form-textarea {
          min-height: 100px;
          resize: vertical;
        }

        .form-row {
          display: flex;
          gap:3px 1.5rem;
        }

        .form-row > .form-group {
          flex: 1;
        }

        /* Image Side Styles */
        .create-profile-image-side {
          width: 40%;
          position: relative;
          background-color: #F8E1E7;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .couple-image {
          width: 100%;
          height:100%;
          margin-bottom: 20px;
        }

        .image-overlay {
          text-align: center;
          max-width: 400px;

        }

        .overlay-heading {
          font-size: 1.8rem;
          color: #fff;
          margin-bottom: 1rem;
          line-height: 1.3;
          font-weight:bold;
        }

        .overlay-text {
          font-size: 1rem;
          color: #fff;
          line-height: 1.6;
                    font-weight:bold;

        }

        .highlight {
          color: #ffc107;
          font-weight: 600;
        }

        .create-btn {
          padding: 12px;
          background-color: #ff4d6d;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
          margin-top: 2rem;
        }

        .loading, .error {
          padding: 2rem;
          text-align: center;
          font-size: 1.2rem;
        }

        .error {
          color: #E53D5C;
        }

        /* Responsive styles */
        @media (max-width: 768px) {
          .create-profile-container {
            flex-direction: column;
            height: auto;
          }
          
          .create-profile-form-side,
          .create-profile-image-side {
            width: 100%;
          }
          
          .form-row {
            flex-direction: column;
            gap:3px 1rem;
          }
            .css-13cymwt-control {
            border-color: #dee2e6 !important ;
            }
          .css-13cymwt-control:hover {
            border-color: #dee2e6 !important ;
            }
        }


        @media (max-width:700px){
        .create-profile-form-side{
        padding:0 15px
        }
        }



        `}
        </style>
      </div>

      <Footer></Footer>

    </>
  );
};

export default EditProfile;